<template>
<div>
  <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
    <el-row>
      <el-col :span="12">
        <el-form-item label="护工人员" prop="esp_id">
          <el-select v-fixZoom v-model="addEditForm.esp_id" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in espArr" :key="item.id" :label="item.service_personnel_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="服务区域" prop="location_id">
          <el-cascader v-fixZoom style="width: 100%" :options="orgOptions"
                       v-model="addEditForm.location_id" :filterable="true" placeholder="请选择楼层"
                       :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                       ref="orgOptions" @change="changeNodes">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="排班日期" prop="shift_date">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.shift_date"
                          type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="班次类型" prop="shift_type_code">
          <el-select v-fixZoom v-model="addEditForm.shift_type_code" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="item in shiftTypes" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="上班时间" prop="start_time">
          <el-time-picker v-fixZoom style="width: 100%" v-model="addEditForm.start_time"
                          format="HH:mm" value-format="HH:mm" placeholder="HH:mm" :maxTime="addEditForm.end_time">
          </el-time-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="下班时间" prop="end_time">
          <el-time-picker v-fixZoom style="width: 100%" v-model="addEditForm.end_time"
                          format="HH:mm" value-format="HH:mm" placeholder="HH:mm" :minTime="addEditForm.start_time">
          </el-time-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="护理内容" prop="duty_desc">
          <el-input type="textarea" :rows="2" placeholder="请输入" v-model="addEditForm.duty_desc"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="备注" prop="">
          <el-input type="textarea" :rows="2" placeholder="请输入" v-model="addEditForm.remarks"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否替班" prop="">
          <el-checkbox v-model="addEditForm.is_substitute">是</el-checkbox>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {queryserviceperson} from '../../../api/yanglaoyuan'
import {createworkshift, updateworkshift} from '../../../api/yanglaoyuan/eservice'
export default {
  name: 'addEditWork',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    workObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      espArr: [],
      orgOptions: [],
      orgArr: [],
      shiftTypes: [
        {value: 'EARLY', name: '早班'},
        {value: 'MID', name: '中班'},
        {value: 'LATE', name: '晚班'},
        {value: 'NIGHT', name: '夜班'}
      ],
      addEditForm: {
        id: 0,
        eid: '',
        esp_id: '',
        shift_date: '',
        shift_type_code: '',
        start_time: '',
        end_time: '',
        location_id: '',
        location_name: '',
        duty_desc: '',
        is_substitute: false,
        remarks: ''
      },
      addEditRules: {
        shift_date: [{required: true, message: '请选择排班日期', trigger: 'change'}],
        shift_type_code: [{ required: true, message: '请选择班次类型', trigger: 'change' }],
        start_time: [{required: true, message: '请选择上班时间', trigger: 'change'}],
        end_time: [{ required: true, message: '请选择下班时间', trigger: 'change' }],
        location_id: [{ required: true, message: '请选择服务区域', trigger: 'change' }],
        is_substitute: [{ required: true, message: '请选择是否替班', trigger: 'change' }],
        duty_desc: [{ required: true, message: '请输入护理内容', trigger: 'blur' }],
        esp_id: [{ required: true, message: '请选择护工', trigger: 'change' }]
      }
    }
  },
  created () {
    this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
    console.log(this.addEditForm.eid)
    this.orgArr = this.workObj.orgArr
    this.startData()
    this.getOrTree1()
    this.getServicePersonData()
  },
  methods: {
    startData (v) {
      if (!this.workObj.isAdd) {
        this.addEditForm.id = this.workObj.row.id
        this.addEditForm.eid = this.workObj.row.eid
        this.addEditForm.esp_id = this.workObj.row.esp_id
        this.addEditForm.shift_date = this.workObj.row.shift_date
        this.addEditForm.shift_type_code = this.workObj.row.shift_type_code
        this.addEditForm.start_time = this.workObj.row.start_time
        this.addEditForm.end_time = this.workObj.row.end_time
        this.addEditForm.location_id = this.workObj.row.location_id
        this.addEditForm.location_name = this.workObj.row.location_name
        this.addEditForm.duty_desc = this.workObj.row.duty_desc
        this.addEditForm.remarks = this.workObj.row.remarks
        this.addEditForm.is_substitute = this.workObj.row.is_substitute
      }
    },
    getOrTree1 () {
      // 所属组织
      let lastLevel = 100
      const arr = []
      for (let i = 0; i < this.orgArr.length; i++) {
        let obj = this.clone(this.orgArr[i])
        if (this.orgArr[i].org_type === 0 || this.orgArr[i].org_type === 1) {
          obj.disabled = true
        } else {
          obj.disabled = false
        }
        arr.push(obj)
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      let treeData = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          treeData.push(arr[i])
        }
      }
      for (let i = 0; i < treeData.length; i++) {
        const child = this.arrayToNode1(arr, treeData[i].id)
        if (child.length !== 0) {
          treeData[i].child = child
        }
      }
      this.orgOptions = treeData
    },
    arrayToNode1 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode1(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    changeNodes () {
      let node = this.$refs.orgOptions.getCheckedNodes()
      this.addEditForm.location_name = node[0].data.name
      console.log(node[0].data, this.addEditForm.location_id, this.addEditForm.location_name)
    },
    getServicePersonData () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        e_id: this.$store.state.user.LoginResp.entity_id
      }
      queryserviceperson(params, data).then(res => {
        this.espArr = res.data.serviceperson
      }).catch(() => {})
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      console.log(this.addEditForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            eid: this.addEditForm.eid,
            esp_id: this.addEditForm.esp_id,
            shift_date: this.addEditForm.shift_date,
            shift_type_code: this.addEditForm.shift_type_code,
            start_time: this.addEditForm.start_time.length === 5 ? this.addEditForm.start_time + ':00' : this.addEditForm.start_time,
            end_time: this.addEditForm.end_time.length === 5 ? this.addEditForm.end_time + ':00' : this.addEditForm.end_time,
            location_id: this.addEditForm.location_id,
            location_name: this.addEditForm.location_name,
            duty_desc: this.addEditForm.duty_desc,
            is_substitute: this.addEditForm.is_substitute,
            remarks: this.addEditForm.remarks
          }
          if (this.workObj.isAdd) {
            createworkshift(data).then(res => {
              this.$notify({title: '成功', message: '成功新建排班', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            data.id = this.addEditForm.id
            updateworkshift(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑排班', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditWork.vue